import * as React from "react";
import DOMPurify from "dompurify";
const Sanitize = ({ html, config = void 0, ...rest }) => {
  const sanitized = DOMPurify.sanitize(html != null ? html : "", config != null ? config : {});
  return /* @__PURE__ */ React.createElement("span", { ...rest, dangerouslySetInnerHTML: { __html: sanitized } });
};
export default Sanitize;
